import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import MailIcon from '@mui/icons-material/Mail';
import ImageIcon from '@mui/icons-material/Image';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import { Typography } from 'src/components/new/Typography';

interface EstimationsProps {
  metrics: {
    minutesReclaimed: number,
    noticesSent: number,
    jobsCompleted: number
  }
}

const Estimations = ({ metrics }: EstimationsProps) => {
  const estimations = [
    {
      label: 'Minutes Reclaimed',
      value: metrics.minutesReclaimed.toLocaleString('en-US'),
      type: 'minutes',
    },
    {
      label: 'Notices Sent',
      value: metrics.noticesSent.toLocaleString('en-US'),
      type: 'notices',
    },
    {
      label: 'Jobs Completed',
      value: metrics.jobsCompleted.toLocaleString('en-US'),
      type: 'pages',
    },
  ];

  const renderEstimationIcon = (type: string) => {
    switch (type) {
      case 'savings':
        return <MonetizationOnIcon sx={{ fontSize: '1rem', marginRight: '0.625rem' }} />;
      case 'notices':
        return <MailIcon sx={{ fontSize: '1rem', marginRight: '0.625rem' }} />;
      case 'pages':
        return <ImageIcon sx={{ fontSize: '1rem', marginRight: '0.625rem' }} />;
      case 'minutes':
        return <AccessTimeFilledIcon sx={{ fontSize: '1rem', marginRight: '0.625rem' }} />;
      default:
        return '';
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        gap: '0.9375rem',
        width: '70%',
        marginBottom: '1.875rem',
      }}
    >
      {estimations.map((item, index) => {
        const isFirst = index === 0;
        return (
          <div
            key={index}
            style={{
              padding: '0.625rem',
              background: isFirst ? '#0a0c2f' : '#F6F6F6',
              color: isFirst ? '#fff' : '#1D1B20',
              flex: 1,
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              {renderEstimationIcon(item.type)}
              <Typography fontWeight={500}>{item.label}</Typography>
            </div>
            <Typography sx={{ fontSize: '1.5625rem', marginTop: '0.625rem', marginBottom: '0.3125rem' }}>{item.value}</Typography>
          </div>
        );
      })}
    </div>
  );
};

export default Estimations;
